
import "./pLogin/pLogin.sass";
import "./pPasswordReset/pPasswordReset.sass";

import { pLoginDirective } from './pLogin/pLogin.directive';
import { pPasswordResetDirective } from './pPasswordReset/pPasswordReset.directive';
import { AuthService } from './Auth.service';

export default angular.module('frontend.auth', [])
  .directive('pLogin', pLoginDirective)
  .directive('pPasswordReset', pPasswordResetDirective)
  .service('Auth', AuthService);
